import { render, staticRenderFns } from "./AchievedGoals.vue?vue&type=template&id=67c57da8&scoped=true&"
import script from "./AchievedGoals.vue?vue&type=script&lang=js&"
export * from "./AchievedGoals.vue?vue&type=script&lang=js&"
import style0 from "./AchievedGoals.vue?vue&type=style&index=0&id=67c57da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c57da8",
  null
  
)

export default component.exports